module.exports = __webpack_public_path__ + "static/equil-4b291cae1eb07306047cf8477d5a37a5.png";